import { configureStore } from "@reduxjs/toolkit";
import categoryReducer from "./features/slices/categorySlice";
import marcaReducer from "./features/slices/marcaSlice";
import userReducer from "./features/slices/userSlice";
import almacenReducer from "./features/slices/almacenSlice";
import medidaReducer from "./features/slices/medidaSlice";
import proveedorReducer from "./features/slices/proveedorSlice";
import productoReducer from "./features/slices/productoSlice";
import kardexReducer from "./features/slices/kardexSlice";
import ventaReducer from "./features/slices/ventaSlice";
import compraReducer from "./features/slices/compraSlice";
import consultaReniecReducer from "./features/slices/consultaReniecSlice";
import cartReducer from "./features/slices/cartSlice";
import cajaReducer from "./features/slices/cajaSlice";
import operacionReducer from "./features/slices/operacionSlice";
import movimientoReducer from "./features/slices/movimientoSlice";
import clienteReducer from "./features/slices/clienteSlice";
import asistenciaReducer from "./features/slices/asistenciaSlice";
import reporteReducer from "./features/slices/reporteSlice";

const Store = configureStore({
  reducer: {
    userReducer: userReducer,
    categoryReducer: categoryReducer,
    marcaReducer: marcaReducer,
    almacenReducer: almacenReducer,
    medidaReducer: medidaReducer,
    proveedorReducer: proveedorReducer,
    productoReducer: productoReducer,
    kardexReducer: kardexReducer,
    ventaReducer: ventaReducer,
    compraReducer: compraReducer,
    consultaReniecReducer: consultaReniecReducer,
    cartReducer: cartReducer,
    cajaReducer: cajaReducer,
    operacionReducer: operacionReducer,
    movimientoReducer: movimientoReducer,
    clienteReducer: clienteReducer,
    asistenciaReducer: asistenciaReducer,
    reporteReducer: reporteReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
    ]),
});
export default Store;
